import { ICustomer } from "@signal/asp-data-commons";
import * as util from "../../shared/services/util.service";

export const formatPhoneNumber = (customers: ICustomer[]) => {
    const customerList = [];
    if(Array.isArray(customers)) {
        customers.forEach(customer => {
            const number = customer?.phoneNumber;
            let phoneNumber = '';
            if(number) {
                if(number?.includes('+')) {
                    phoneNumber = number;
                }
                else if(number?.length > 10 ) {
                    if(number?.length === 11 && number[0] === '1') {
                        phoneNumber = `+1${number?.substring(1)}`;
                    }
                    else if(number?.length === 12 && number?.substring(0,2) === '52') {
                        phoneNumber = `+52${number?.substring(2)}`;
                    }
                }
                else if(number?.length === 10) {
                    phoneNumber = util.countryCd?.toUpperCase()?.includes('US') ? '+1' + number : '+52' + number;
                }
            }
            customerList.push({...customer, phoneNumber});
        })
    }
    return customerList;
}